import Grid from '@mui/material/Unstable_Grid2'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import {
  CountryAutocomplete,
  CustomTextField,
  PostalcodeAutocomplete,
  ProvinceAutocomplete,
  TownAutocomplete
} from '../../../../../../shared/components/inputs'
import { IUser } from '../../../../models/user'
import { RoleSelect } from '../../forms/RoleSelect'
import { UserLanguageAutocomplete } from '../../forms/UserLanguageAutocomplete'

interface GeneralTabProps {
  user: IUser
  handleInputChange: (inputName: string, value: any) => void
}

export function GeneralTab({ user, handleInputChange }: GeneralTabProps) {
  const { errorEmailFound, loadingFindEmail, msgEmailFound } = useSelector((state: IRootState) => state.user)

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={6} md={4}>
        <RoleSelect roleId={user.role_id} handleInputChange={handleInputChange} />
      </Grid>

      <Grid xs={12} sm={6} md={4}>
        <CountryAutocomplete value={user.country} handleInputChange={handleInputChange} />
      </Grid>

      <Grid xs={12} sm={6} md={4}>
        <UserLanguageAutocomplete userLanguages={user.languages} handleInputChange={handleInputChange} />
      </Grid>

      <Grid xs={12} sm={6} md={4}>
        <ProvinceAutocomplete value={user.province} country={user.country} handleInputChange={handleInputChange} />
      </Grid>

      <Grid xs={12} sm={6} md={4}>
        <TownAutocomplete value={user.town} province={user.province} handleInputChange={handleInputChange} />
      </Grid>

      <Grid xs={12} sm={6} md={4}>
        <PostalcodeAutocomplete value={user.postalcode} province={user.province} handleInputChange={handleInputChange} />
      </Grid>

      <Grid xs={12} sm={6} md={3}>
        <CustomTextField inputName={'address'} value={user.address} handleInputChange={handleInputChange} />
      </Grid>

      <Grid xs={12} sm={6}>
        <CustomTextField
          inputName={'email'}
          value={user.email}
          handleInputChange={handleInputChange}
          required={true}
          error={errorEmailFound}
          errorMsg={msgEmailFound}
        />
      </Grid>

      <Grid xs={12} sm={6} md={3}>
        <CustomTextField inputName={'phone'} value={user.phone} handleInputChange={handleInputChange} />
      </Grid>
    </Grid>
  )
}
